const $ = window.$;

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});
